
const INDIAN_FY_DATERANGE_KIND = ['Previous Indian FY', 'Current Indian FY', 'Next Indian FY'] as const;
const CALENDAR_YEAR_DATERANGE_KIND = ['Previous Calendar Year', 'Current Calendar Year', 'Next Calendar Year'] as const;

export const PreDefinedDateRangeKinds = [...CALENDAR_YEAR_DATERANGE_KIND, ...INDIAN_FY_DATERANGE_KIND];

export type PreDefinedDateRangeKindType = typeof CALENDAR_YEAR_DATERANGE_KIND[number] | typeof INDIAN_FY_DATERANGE_KIND[number];